module.exports = __webpack_public_path__ + "static/media/grid1.b606d088.svg";